/* @flow */
import React, { Fragment, useState } from 'react';
import InfoCard from '../../InfoCard';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@cmsgov/ds-healthcare-gov';
import warning from '../../../images/warning.svg';
import { sendEvent } from '../../../utilities/analytics';
import './NextSteps.scss';

type Props = {
  clearForm: () => void,
  buildPDF: () => void,
};

export const NextSteps = ({ clearForm, buildPDF }: Props) => {
  const [shouldShowModal, setShouldShowModal] = useState<boolean>(false);
  const { t } = useTranslation();

  const showModal = () => {
    setShouldShowModal(true);
  };
  const hideModal = () => {
    setShouldShowModal(false);
  };
  const handleClearForm = () => {
    hideModal();
    clearForm();
  };
  const handlePrint = () => {
    sendEvent('print', 'pdf', 'income-estimate.pdf', 'print_page');
    window.print();
  };

  const dialogHeader = (
    <div>
      <img className="ic-clear-form-warning ds-u-valign--middle ds-u-margin-right--1" src={warning} alt="Alert." />
      <span id="clear-form-header" className="ds-u-valign--middle">
        {t('clearFormAlertHeader')}
      </span>
    </div>
  );

  return (
    <Fragment>
      <div className="ds-l-row">
        <div className="ds-l-md-col--12">
          <InfoCard>
            <div id="next-steps-title" className="ds-u-font-weight--bold">
              {t('nextStepsTitle')}
            </div>
            <ol className="ds-c-list" aria-labelledby="next-steps-title">
              <li className="ds-u-font-weight--bold">
                <div>{t('nextStepsBody1')}</div>
                <div className="ds-u-font-weight--normal ds-u-display--flex ds-u-margin-top--1 ds-u-margin-bottom--2 ds-u-align-items--center">
                  <img
                    className="ic-clear-form-warning ds-u-valign--middle ds-u-margin-right--1"
                    src={warning}
                    alt="Alert."
                  />
                  <span id="ic-next-steps">{t('nextStepsBody1Warning')}</span>
                </div>
                <div className="ds-u-margin-top--1 ds-u-padding-bottom--1">
                  <Button
                    onClick={handlePrint}
                    className="ic-print-btn ds-u-margin-right--1 ds-u-margin-bottom--1 ds-u-sm-margin-bottom--0"
                  >
                    {t('print')}
                  </Button>
                  <Button onClick={buildPDF}>{t('downloadPDF')}</Button>
                </div>
              </li>
              <li className="ds-u-font-weight--bold">
                <div>{t('nextStepsBody2')}</div>
                <Button variation="ghost" className="ds-u-margin-top--1 ic-clear-form-btn" onClick={showModal}>
                  {t('clearForm')}
                </Button>
              </li>
            </ol>
          </InfoCard>
        </div>
      </div>
      {shouldShowModal && (
        <Dialog
          onExit={hideModal}
          heading={dialogHeader}
          closeText={t('close')}
          actions={[
            <Button variation="solid" onClick={handleClearForm} className="ic-clear-form-confirm">
              {t('clearForm')}
            </Button>,
            <Button variation="ghost" onClick={hideModal}>
              {t('cancel')}
            </Button>,
          ]}
        >
          {t('clearFormAlertBody')}
        </Dialog>
      )}
    </Fragment>
  );
};

// $FlowFixMe
export default React.memo(NextSteps);
